import React, { useState, Fragment } from "react";
import { useSelector } from "react-redux";
import Loader from "../Loader/loader";
import EditRequest from "./editRequest";
import FileRecord from "./FileRecord";
import ResetRequest from "./ResetRecords";
import "./reqtable.css";
import Tooltip from "@material-ui/core/Tooltip";
import { Icon } from "semantic-ui-react";
import moment from "moment";
import { useMemo } from "react/cjs/react.production.min";
function RequestRecords(props) {
  const EventTypeResponse = {
    GB: "ediTxnRequest",
    US: "ediTxnRequest",
    CA: "cbsaTxnRequest",
    CA_CARM: "carmTransactionResponses"
  };
  const country = props.isXMLEnabled ? "CA_CARM" : window.shipmentCountry || props.countryOfBusiness;
  const PopupRecords = useSelector((state) => state.ediReq?.popupRecords);
  const PopupShow = useSelector((state) => state.ediReq.popUpShow);
  const [textCopied, setTextCopied] = useState(false);
  const generateEdiError = useSelector(
    (state) => state.ediReq.ediReqRecords?.eventMessage
  );
  const FindPopUpLength = () => {
    let PopupRecord = [...PopupRecords.recordlist];

    let arr = [];
    for (let i = 0; i < PopupRecord?.length; i++) {
      arr.push(PopupRecord[i].record.length);
    }

    return Math.max(...arr);
  };

  const createDyanamicArray = (len) => {
    let arr = [];
    for (var i = 0; i <= len; i++) {
      arr.push(i.toString());
    }
    return arr;
  };

  const selectedRow = useSelector((state) => state.rowSelected?.selectedRow);
  const PopupRecordsLength = FindPopUpLength();
  let PopupRecordsLengthArray = [];
  if (PopupRecordsLength !== undefined && PopupRecordsLength !== -Infinity) {
    PopupRecordsLengthArray = createDyanamicArray(PopupRecordsLength);
  }

  // if(PopupRecordsLength!==undefined && PopupRecordsLength!== -Infinity)
  //   PopupRecordsLengthArray = [...Array(PopupRecordsLength)];

  const Records = useSelector(
    (state) =>
      state.ediReq.ediReqRecords?.eventMessage?.[EventTypeResponse[country]]
  );
  const recordMaxLength = useSelector(
    (state) =>
      state.ediReq.ediReqRecords?.eventMessage?.[EventTypeResponse[country]]
  );
  const loader = useSelector((state) => state.ediReq.loading);
  const getRecords = () => {
    return Records ? Records[0].records : [];
  };
  const getIsPSC = () => {
    return Records ? Records[0].isPSC == 1 : false;
  };

  const getMaxLength = () => {
    return recordMaxLength ? recordMaxLength[0].maxLength : [];
  };

  const getTableData = (index, reqrecords) => {
    return reqrecords.record.split("")[index]
      ? reqrecords.record.split("")[index]
      : "";
  };
  let recordsToDisplay = getRecords();
  let MaxLength = getMaxLength();
  let MaxLengthArray = [];
  if (MaxLength !== undefined) {
    MaxLengthArray = createDyanamicArray(MaxLength);
  }
  // MaxLengthArray = [...Array(MaxLength + 1)];

  const statusCode = useSelector(
    (state) => state.ediReq.ediReqRecords?.eventMessage?.code
  );
  const statusMessage = useSelector(
    (state) => state.ediReq.ediReqRecords?.eventMessage?.msg
  );

  const copytoclipboard = () => {
    if (PopupShow) {
      let emptyArr = [];
      let finalArray = "";
      for (let i = 0; i < PopupRecords.recordlist.length; i++) {
        {
          country === "US"
            ? emptyArr.push(
                PopupRecords.recordlist[i] &&
                  "[" + PopupRecords.recordlist[i].record + "]"
              )
            : emptyArr.push(
                PopupRecords.recordlist[i] && PopupRecords.recordlist[i].record
              );
        }
      }
      finalArray = emptyArr.join("\n");
      navigator.clipboard.writeText(finalArray);
      setTextCopied(true);
      hidecopiedtextalert();
    } else {
      let emptyArr = [];
      let finalArray = "";
      for (let i = 0; i < recordsToDisplay.recordlist.length; i++) {
        {
          country === "US"
            ? emptyArr.push(
                recordsToDisplay.recordlist[i] &&
                  "[" + recordsToDisplay.recordlist[i].record + "]"
              )
            : emptyArr.push(
                recordsToDisplay.recordlist[i] &&
                  recordsToDisplay.recordlist[i].record
              );
        }
      }
      finalArray = emptyArr.join("\n");
      navigator.clipboard.writeText(finalArray);
      setTextCopied(true);
      hidecopiedtextalert();
    }
  };

  const hidecopiedtextalert = () => {
    setTimeout(() => {
      setTextCopied(false);
    }, 2000);
  };
  let j,
    color = "#267675";
  return (
    <div>
      {loader == true && (
        <div style={{ textAlign: "center" }}>
          <Loader />
        </div>
      )}

      {recordsToDisplay &&
      Object.keys(recordsToDisplay).length > 0 &&
      loader == false ? (
        <div>
          <h1>Request Records </h1>
          <div>
            {selectedRow.requestTime && (
              <span>
                <strong>Request Filed On: </strong>
                {`${moment(new Date(selectedRow.requestTime)).format(
                  "MM-DD-YY hh:mm:ss"
                )} ${selectedRow.responseTimeZone || ""}`}
              </span>
            )}
            {getIsPSC()?
              <span style={{color:'orange'}}><br/>
             Warning: This generated EDI is for PSC. Please move to PSC section to perform such action !!!
             
              </span>
            :null}
            {selectedRow.fileReason && (
              <span>
                <strong> Filed Reason: </strong>
                {selectedRow.fileReason}
              </span>
            )}
          </div>
          <br />
          <div>
            {!selectedRow.requestTime && !PopupShow && !((props||{}).readOnlyMode) && (
              <div className="alert">
                Warning <span style={{ fontSize: "15px" }}>&#x26A0;</span>{" "}
                <span>
                  - This is a system generated EDI , you can edit this EDI and
                  file It.
                </span>{" "}
              </div>
            )}

            <Tooltip
              placement="top"
              arrow
              title="Copy To Clipboard"
              aria-label="Copy To Clipboard"
            >
              <Icon
                name="file alternate outline"
                disabled={textCopied ? true : false}
                onClick={copytoclipboard}
                style={{ fontSize: "18px", cursor: "pointer" }}
              />
            </Tooltip>
            {textCopied && (
              <span id="copied-text-span">copied successfully !</span>
            )}
            {PopupShow && <ResetRequest {...props} />}
            {PopupShow && (
              <FileRecord
                shipmentId={props.shipmentId}
                countryOfBusiness={props.countryOfBusiness}
                {...props}
              />
            )}
            {!props.readOnlyMode && <EditRequest {...props} />}
            <br />
          </div>

          {selectedRow.requestTime && <React.Fragment><b>
                [UTC: {moment(new Date(selectedRow.requestTime+" "+(selectedRow.responseTimeZone||"GMT"))).tz("UTC").format('ddd, MMM DD YYYY, HH:mm zz')}]
                [EST: {moment(new Date(selectedRow.requestTime+" "+(selectedRow.responseTimeZone||"GMT"))).tz('America/New_York').format('ddd, MMM DD YYYY, HH:mm zz')}]
              </b><br/></React.Fragment>}


          <div className="req-table-wrap">
            <table className="req-table">
              <thead>
                <tr>
                  {!PopupShow
                    ? MaxLength &&
                      MaxLengthArray.map((e, i) => {
                        color = "#267675";
                        if (i % 10 == 0) {
                          j = i;
                          color = "#60afad";
                        }
                        return (
                          <th style={{ backgroundColor: color }} key={i}>
                            {!i ? "" : j && i > j ? i - j : i}
                          </th>
                        );
                      })
                    : PopupRecordsLength &&
                      PopupRecordsLengthArray.map((e, i) => (
                        <th key={i}>{i + 1}</th>
                      ))}
                </tr>
              </thead>
              <tbody>
                {!PopupShow
                  ? recordsToDisplay.recordlist.map((reqrecords, i) => (
                      <tr key={i}>
                        {MaxLength &&
                          MaxLengthArray.map((e, j) => (
                            <td key={j} className={j === 0 ? "rowcounter" : ""}>
                              {j === 0 ? (
                                <span>{i + 1}</span>
                              ) : (
                                getTableData(j - 1, reqrecords)
                              )}
                            </td>
                          ))}
                      </tr>
                    ))
                  : PopupRecords.recordlist.map((reqrecords, i) => (
                      <tr key={i}>
                        {PopupRecordsLength &&
                          PopupRecordsLengthArray.map((e, i) => (
                            <td key={i}>{getTableData(i, reqrecords)}</td>
                          ))}
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
          <hr />
        </div>
      ) : recordsToDisplay &&
        Object.keys(recordsToDisplay).length == 0 &&
        loader == false &&
        !PopupShow ? (
        <Fragment>
          {country === "US" && statusCode && statusCode == 403 && (
            <div className="alert">
              Warning <span style={{ fontSize: "15px" }}>&#x26A0;</span>{" "}
              <span>
                - System couldn't generate EDI because {statusMessage}
              </span>{" "}
            </div>
          )}
          {generateEdiError?.code == 400 && (
            <div className="alert">
              Warning <span style={{ fontSize: "15px" }}>&#x26A0;</span>{" "}
              <span>
                - System cannot generate EDI because {generateEdiError.msg}
              </span>{" "}
            </div>
          )}
          <h3 style={{ textAlign: "center", fontFamily: "Courier New" }}>
            No request record found !
          </h3>
          <table className="req-table">
            <thead>
              <tr>
                {[...new Array(50)].map((e, i) => (
                  <th key={i}>{i + 1}</th>
                ))}
              </tr>
            </thead>
          </table>

          <div style={{ textAlign: "center" }}>
            <span style={{ marginRight: "48%", display: "block" }}>
              {!props.readOnlyMode && <EditRequest {...props} />}
            </span>
            <br />
            <br />
            {selectedRow && (
              <h3 style={{ fontFamily: "Courier New", display: "inline-flex" }}>
                Click on "Edit" to manually add EDI for RequestId :{" "}
                {selectedRow.requestid}
              </h3>
            )}

            <hr />
          </div>
        </Fragment>
      ) : recordsToDisplay &&
        Object.keys(recordsToDisplay).length == 0 &&
        loader == false &&
        PopupShow ? (
        <div>
          <h1>Request Records</h1>
          <Tooltip
            placement="top"
            arrow
            title="Copy To Clipboard"
            aria-label="Copy To Clipboard"
          >
            <Icon
              name="file alternate outline"
              disabled={textCopied ? true : false}
              onClick={copytoclipboard}
              style={{ fontSize: "18px", cursor: "pointer" }}
            />
          </Tooltip>

          {textCopied && (
            <span id="copied-text-span">copied successfully !</span>
          )}
          {PopupShow && <ResetRequest {...props} />}
          {PopupShow && (
            <FileRecord
              shipmentId={props.shipmentId}
              countryOfBusiness={props.countryOfBusiness}
              {...props}
            />
          )}

          {!props.readOnlyMode && <EditRequest {...props} />}

          {selectedRow && <h3>Request ID : {selectedRow.requestid}</h3>}

          <br />
          <div className="req-table-wrap">
            <table className="req-table">
              <thead>
                <tr>
                  {PopupRecordsLength &&
                    PopupRecordsLengthArray.map((e, i) => (
                      <th key={i}>{i + 1}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {PopupRecords.recordlist.map((reqrecords, i) => (
                  <tr key={i}>
                    {PopupRecordsLength &&
                      PopupRecordsLengthArray.map((e, i) => (
                        <td key={i}>{getTableData(i, reqrecords)}</td>
                      ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <hr />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default React.memo(RequestRecords);
